// TODO add authorization middleware and auth meta data
const profileRoutes = [
  {
    path: 'info',
    name: 'profile',
    component: () => import('@/views/Profile/ChildProfile'),
    meta: {
      title: 'Profile',
    },
  },
  {
    path: 'switch',
    name: 'switch-child',
    component: () => import('@/views/Profile/SwitchChild'),
    meta: {
      title: 'Switch Child Account',
    },
  },
  {
    path: 'events',
    name: 'profile-events',
    component: () => import('@/views/Profile/EventsPage'),
    meta: {
      title: 'Events',
    },
  },
  {
    path: 'chats',
    name: 'profile-chats',
    component: () => import('@/views/Profile/Chats/ChatsPage'),
    meta: {
      title: 'Chats',
    },
    children: [
      {
        path: ':chatId',
        name: 'profile-chat-messages',
        component: () => import('@/views/Profile/Chats/ChatWindowPage'),
        meta: {
          title: 'Chat',
        },
      },
    ],
  },
  {
    path: 'classes',
    name: 'profile-classes',
    component: () => import('@/views/Profile/ClassSelection'),
    meta: {
      title: 'Classes',
    },
  },
  {
    path: 'assignments',
    name: 'profile-assignments',
    component: () => import('@/views/Profile/Assignments/AssignmentsPage'),
    meta: {
      title: 'Assignments',
    },
  },
  {
    path: 'assignments/:assignmentId',
    name: 'profile-assignment',
    component: () => import('@/views/Profile/Assignments/AssignmentDetailsPage'),
    meta: {
      title: 'Assignment',
    },
  },
  {
    path: 'assignments/:assignmentId/test',
    name: 'profile-assignment-test',
    component: () => import('@/views/Profile/Assignments/AssignmentTestPage'),
    meta: {
      title: 'Assignment test',
    },
  },
  {
    path: 'grades',
    name: 'profile-grades',
    component: () => import('@/views/Profile/Grades/GradesPage'),
    meta: {
      title: 'Academic success',
    },
  },
];

function prepareRoutes(routes) {
  const extendMeta = (route) => {
    const defaultMetaData = { showMenuWidget: false };
    const meta = Object.assign(defaultMetaData, route.meta);

    const children = ('children' in route) ? route.children.map(extendMeta) : route.children;

    return { ...route, meta, children };
  };

  return routes.map(extendMeta);
}

export default prepareRoutes(profileRoutes);
